import React from 'react';

export function usePersistedState<Type>(key: string, initialState: Type) {
  const useStateResult = React.useState<Type>(() => {
    if (typeof window === 'undefined') {
      // Server side
      return initialState;
    }
    return JSON.parse(localStorage.getItem(key) as string) || initialState;
  });
  // It seem like an unnecessary step to not destructure right away, but it's
  // done this way to keep the type definition intact
  const [state] = useStateResult;
  React.useEffect(() => {
    localStorage.setItem(key, JSON.stringify(state));
  }, [key, state]);
  return useStateResult;
}
